import React, { Component } from "react";
import { Container, Table, Button } from "reactstrap";
//import { TransitionGroup, CSSTransition } from "react-transition-group";
import { connect } from "react-redux";
import { getDevices, deleteDevice } from "../actions/deviceActions";
import PropTypes from "prop-types";
import { getUsersDevices } from "../actions/usersDevicesActions";
import { getUsersLogs } from "../actions/usersLogsActions";

class Devices extends Component {
  componentDidMount() {
    if (this.props.auth.user) {
      this.props.getDevices(this.props.auth.user[0].username);
    }
  }

  static propTypes = {
    auth: PropTypes.object.isRequired,
    deleteDevice: PropTypes.func.isRequired,
    getDevices: PropTypes.func.isRequired
  };

  onDeleteClick = id => {
    this.props.deleteDevice(id);
    if (this.props.auth.user[0].isAdmin === "Yes") {
      this.props.getUsersDevices();
      this.props.getUsersLogs();
    }
  };
  render() {
    const { devices } = this.props.device;

    let pw = "";
    if (devices.length > 0) {
      pw = devices[0].userPassword;
    }

    return (
      <Container>
        <br />
        <h3>
          {devices.length
            ? `Please use the password generated for all your registered
        devices.`
            : "Add a device to generate a password to use for all your devices."}
        </h3>

        <h2 className="pw">{devices.length ? `Password: ${pw}` : ""}</h2>

        <Table responsive className="ml-10">
          <thead>
            <tr>
              <th>Name</th>
              <th>Mac Address</th>
              <th>Registration Time</th>
              <th>Password</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {devices.map(
              ({
                deviceId,
                deviceMAC,
                deviceName,
                registrationTime,
                userPassword
              }) => (
                <tr key={deviceId}>
                  <th scope="row">{deviceName}</th>
                  <td>{deviceMAC}</td>
                  <td>{registrationTime.slice(0, 19)}</td>
                  <td>{userPassword}</td>
                  <td>
                    <Button
                      className="remove-btn"
                      color="danger"
                      size="sm"
                      onClick={this.onDeleteClick.bind(this, deviceId)}>
                      &times;
                    </Button>
                  </td>
                </tr>
              )
            )}
          </tbody>
        </Table>
      </Container>
    );
  }
}

Devices.propTypes = {
  getDevices: PropTypes.func.isRequired,
  device: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  device: state.device,
  auth: state.auth
});

export default connect(mapStateToProps, {
  getDevices,
  deleteDevice,
  getUsersDevices,
  getUsersLogs
})(Devices);
